export const errorCode = {
    participantPublicAccessTokenInvalid: "ParticipantPublicAccessTokenInvalid",
}

export const errorMessageClient = {
    participantNotFound: "Participant is not existing or has been deleted",
}
export const errorApiMessage = {
    participantNotFound: "No participant found",
}
